var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHitPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.875C15 5.875 14.9976 4 13.6047 4C12.1047 4 12 5.41176 12 6.23529V16",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.875C22 5.875 21.9976 4 20.6047 4C19.1047 4 19 5.41176 19 6.23529V16",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H19M12 11H19M12 14H19",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16L2.44844 16.3501C2.95013 16.7418 3.64098 16.7849 4.18748 16.4587V16.4587C4.6625 16.175 5.25308 16.1677 5.735 16.4395L5.86702 16.5139C6.40393 16.8167 7.0583 16.8241 7.60197 16.5337L7.78842 16.4341C8.29055 16.1658 8.89818 16.1885 9.3789 16.4935V16.4935C9.87052 16.8054 10.4938 16.8215 11.001 16.5356L11.1135 16.4721C11.6365 16.1772 12.2724 16.1632 12.8079 16.435L13.05 16.5579C13.5943 16.8341 14.2405 16.8199 14.7721 16.5202L14.845 16.4791C15.3704 16.1828 16.0142 16.1908 16.532 16.5V16.5C17.0499 16.8092 17.6937 16.8172 18.219 16.5209L18.3689 16.4364C18.8493 16.1655 19.4364 16.1655 19.9169 16.4365V16.4365C20.5125 16.7723 21.2569 16.6857 21.7595 16.2219L22 16",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5L2.44844 18.8501C2.95013 19.2418 3.64098 19.2849 4.18748 18.9587V18.9587C4.6625 18.675 5.25308 18.6677 5.735 18.9395L5.86702 19.0139C6.40393 19.3167 7.0583 19.3241 7.60197 19.0337L7.78842 18.9341C8.29055 18.6658 8.89818 18.6885 9.3789 18.9935V18.9935C9.87052 19.3054 10.4938 19.3215 11.001 19.0356L11.1135 18.9721C11.6365 18.6772 12.2724 18.6632 12.8079 18.935L13.05 19.0579C13.5943 19.3341 14.2405 19.3199 14.7721 19.0202L14.845 18.9791C15.3704 18.6828 16.0142 18.6908 16.532 19V19C17.0499 19.3092 17.6937 19.3172 18.219 19.0209L18.3689 18.9364C18.8493 18.6655 19.4364 18.6655 19.9169 18.9365V18.9365C20.5125 19.2723 21.2569 19.1857 21.7595 18.7219L22 18.5",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2891 7.5C4.2891 7.5 3.5 8.17073 3.5 8.97561C3.5 10.0488 4.5 10.3171 4.5 11.3902C4.5 12.2488 3.75 13 3.75 13",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2891 7.5C6.2891 7.5 5.5 8.17073 5.5 8.97561C5.5 10.0488 6.5 10.3171 6.5 11.3902C6.5 12.2488 5.75 13 5.75 13",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68365 7.5C8.68365 7.5 7.5 8.17073 7.5 8.97561C7.5 10.0488 9 10.3171 9 11.3902C9 12.2488 7.875 13 7.875 13",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitPool);
export default __webpack_public_path__ + "static/media/hit_pool.aee196c7292125e96511098e966b21e2.svg";
export { ForwardRef as ReactComponent };